import * as getters from './getters';

import actions from './actions';
import mutations from './mutations';

const state = () => ({
  showMobileSidebar: false,
  showCreatePostModal: {
    show: false,
    target: '',
    targetType: '',
    mentionPost: null,
    originalPost: null,
    title: '',
    callback: null,
    dispatch: null,
    context: null,
    transactionData: null,
    league: null,
  },
  showImageSliderModal: {
    show: false,
    navigateTo: 0,
    images: [],
  },
  showSelectProfileModal: false,
  createPortfolioModal: {
    show: false,
    leagueId: null,
    league: null,
    invitationId: null,
    isLeaguePortfolio: false,
  },
  showLegalDisclaimerModal: false,
  mentionHovered: false,
  mentionCardHovered: false,
  hoveredMentionId: null,
  hoveredMentionCardId: null,
  currentMentionCard: null,
  mouseOnMention: null,
  mouseOnMentionCard: null,
  lastMentionCard: {
    profile: null,
  },
  passwordResetModal: {
    show: false,
    step: 1,
  },
  createPortfolioOperationModal: {
    show: false,
    isSubmitting: false,
    multipleTransactions: false,
    portfolioType: null,
    symbol: null,
    portfolio: null,
    operationType: 'Buy',
    symbolLoading: false,
    symbolError: null,
    createOperationError: null,
    createCashOperationError: null,
    tickerValue: null,
    isCashTransaction: false,
    canPerformCashOperation: true,
    currency: '',
    shouldShowOperationSwitcher: false,
    shouldShowOperationButtons: false,
    shouldShowTickerCard: true,
    shouldCheckForLineRule: true,
  },
  createOrderTransactionModal: {
    show: false,
    isSubmitting: false,
    multipleTransactions: false,
    portfolioType: null,
    symbol: null,
    portfolio: null,
    operationType: 'Buy',
    symbolLoading: false,
    symbolError: null,
    createOperationError: null,
    createCashOperationError: null,
    tickerValue: null,
    isCashTransaction: false,
    canPerformCashOperation: true,
    currency: '',
    shouldShowOperationSwitcher: false,
    shouldShowOperationButtons: false,
    shouldShowTickerCard: true,
    shouldCheckForLineRule: true,
  },
  showNoDataAtDateError: false,
  helpCenterObjectRes: {
    show: false,
    showFeedButton: localStorage.getItem('hasClickedHelpCenterButton')
      ? !JSON.parse(localStorage.getItem('hasClickedHelpCenterButton'))
      : true,
    showMain: false,
    showWalkthrough: 0,
    showSettings: false,
    showFeed: 0,
    feedPageAvailable: false,
  },
  showProfileCardRes: {
    show: false,
    profileId: null,
    targetCoordX: 0,
    targetCoordY: 0,
    targetHeight: 0,
  },
  portfolioEmptyStateModal: {
    show: false,
  },
  klipyModal: {
    lastKlipyTrendingSearch: null,
  },
  compareTickersModal: {
    show: false,
    numberOfItemsInComparison: 0,
    selectedTicker: {},
  },
  comparePortfoliosModal: {
    show: false,
    isMyPortfolio: false,
    numberOfItemsInComparison: 0,
  },
  manageTeamPortfolioModal: {
    show: false,
  },
  createLeagueModal: {
    show: false,
  },
  companyTickersListModal: {
    show: false,
  },
  notificationsCenterMenuDrawer: {
    show: false,
  },
  portfolioOptionsDrawer: {
    show: false,
  },
  portfolioGuideDrawer: {
    show: false,
  },
  portfolioGuideModal: {
    show: false,
  },
  portfolioSettingsModal: {
    show: false,
  },
  homePageGuideDrawer: {
    show: false,
  },
  showPortfolioAssetOperationModalFooter: true,
  hasClosedEmailConfirmationBanner: localStorage.getItem(
    'hasClosedEmailConfirmationBanner'
  )
    ? JSON.parse(localStorage.getItem('hasClosedEmailConfirmationBanner'))
    : false,
  mobileSidebar: {
    show: false,
  },
  portfolioOperationConfirmationComponent: {
    show: false,
    itemPayload: null,
    operationPayload: null,
    itemId: null,
    isPublic: false,
    itemCountCondition: false,
    allocationCondition: false,
    transactionModalShouldStayOpen: false,
    lineRuleLimit: null,
  },
  unrankedPortfolioConfirmationComponent: {
    show: false,
    itemPayload: null,
    operationPayload: null,
    itemId: null,
    isPublic: false,
    itemCountCondition: false,
    allocationCondition: false,
    transactionModalShouldStayOpen: false,
  },
  portfolioSelectorModal: {
    show: false,
    portfolios: [],
    symbol: null,
    selectedTicker: null,
    portfolioType: null,
    selectedPortfolio: null,
  },
  openModals: [],
  createOrderModal: {
    show: false,
    isSubmitting: false,
    multipleTransactions: false,
    portfolioType: null,
    symbol: null,
    portfolio: null,
    operationType: 'Buy',
    symbolLoading: false,
    symbolError: null,
    createOperationError: null,
    createCashOperationError: null,
    tickerValue: null,
    isCashTransaction: false,
    canPerformCashOperation: true,
    currency: '',
    shouldShowOperationSwitcher: false,
    shouldShowOperationButtons: false,
    shouldShowTickerCard: true,
    shouldCheckForLineRule: true,
  },
  noEligiblePortfoliosDrawer: {
    show: false,
  },
  noEligiblePortfolioModal: {
    show: false,
  },
  quickstartCompletionModal: {
    show: false,
  },
  showTransactionTypesModal: false,
});

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
